const platformTypes = {
  ALL: 'all',
  PUBLISHER_ONLY: 'publisher',
  NON_PUBLISHER_ONLY: 'nonPublisher',
};

export default platformTypes;
